import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { isNumber } from 'util';
import { Constants } from '../core/Constants';
import { PageModel } from '../core/models/page.model';
import { Helper } from './helper';

@Injectable()
export class PagingService {
  private pageModel = new PageModel();

  constructor(
    private route: ActivatedRoute,
    private router: Router) {
  }

  get PageModel(): PageModel {
    return this.pageModel;
  }

  //setPage(page: number): void {
  setPage(page: number, type: string): void {
    this.pageModel.page = page;
    this.navigate(type);
  }

  //setPageSize(pageSize: number) {
  setPageSize(pageSize: number, type: string): void {
    if (pageSize > this.pageModel.pageSize) {
      // djb: convert current page number based on pageSize
      this.pageModel.page = Math.ceil(this.pageModel.page * (this.pageModel.pageSize / pageSize));
    }
    else {
      this.pageModel.page = ((this.pageModel.page - 1) * Math.floor(this.pageModel.pageSize / pageSize)) + 1;
    }
    this.pageModel.pageSize = pageSize;
    this.navigate(type);
  }

  setSort(sort: string, type: string) {
    this.pageModel.orderBy = sort;
    this.navigate(type);
  }

  // djb:hack-to save paging state before navigation
  savePaging(type: string): void {
    if (type !== null) {
      sessionStorage.setItem(`${type}Paging`, JSON.stringify(this.pageModel));
    } else {
      Helper.log("Invalid paging product type=null");
    }
  }

  restorePaging(type: string): void {
    const p: string = sessionStorage.getItem(`${type}Paging`);
    if (p != null) {
      this.pageModel = JSON.parse(p);
    }
    //this.navigate(type);
  }

  removePaging(type: string): void {
    sessionStorage.removeItem(`${type}Paging`)
  }

  private navigate(type: string): void {
    Helper.log(`ps.navigate{${type}): ${JSON.stringify(this.pageModel)}`);
    // djb:hack-to save paging state before navigation
    this.savePaging(type);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: this.pageModel.page, pageSize: this.pageModel.pageSize, orderBy: this.pageModel.orderBy },
      queryParamsHandling: 'merge'
    });
  }

  initPagingFromSession(type: string): void {
    this.pageModel = JSON.parse(sessionStorage.getItem(`${type}Paging`));
  }


  initPageFromUrl(params: ParamMap, type: string) {
    const page = params.get(Constants.PAGE_PARAM);
    if (page) {
      const value = Number(page);
      if (isNumber(value)) {
        this.pageModel.page = value;
      }
      if (type) {
        this.savePaging(type);
      }
    }
    const pageSize = params.get(Constants.PAGE_SIZE_PARAM);
    if (pageSize) {
      const value = Number(pageSize);
      if (isNumber(pageSize)) {
        this.pageModel.pageSize = value;
      }
    }
    this.pageModel.orderBy = params.get(Constants.ORDER_BY_PARAM);
  }
}
